<section [@routerTransition]>
    <div>
        <div class="config-agenda">
            <button class="btn icon icon-primary" title="Editar agenda" (click)="editarAgenda()">
                <i class="hgi hgi-stroke hgi-settings-02"></i>
            </button>

            <div class="select-agenda" (click)="toggleDropdown()">
                <div class="selected-item">
                    <span>{{ getSelectedAgendaName }}</span>
                    <i *ngIf="dropdownOpen" class="hgi hgi-stroke hgi-arrow-up-01"></i>
                    <i *ngIf="!dropdownOpen" class="hgi hgi-stroke hgi-arrow-down-01"></i>
                </div>
                <div *ngIf="dropdownOpen" class="custom-dropdown">
                    <div *ngFor="let agenda of agendas" (click)="selectAgenda(agenda.id, $event)" class="dropdown-item">
                        {{ agenda.nomeSala }}
                    </div>
                    <div (click)="criarAgenda($event)" class="dropdown-item create-option">
                        <i class="hgi hgi-stroke hgi-plus-sign-circle text-primary"></i>
                        Criar nova agenda
                    </div>
                </div>
            </div>

            <span *ngIf="agenda?.suspenso" class="badge badge-warning badge-sala-suspensa">
                <i class="hgi hgi-stroke hgi-alert-02"></i> Sala Suspensa
            </span>
        </div>

        <ng-container *ngIf="selectedView === 'agendar' && agenda">
            <p class="legenda">Selecione os horários em que você estará disponível para atendimento clicando nos
                horários do calendário abaixo ou no botão “adicionar evento”.</p>
            <custom-calendar #calendario [agenda]="agenda" [gerenciarHorarios]="true"></custom-calendar>
        </ng-container>

    </div>
</section>
